import React from 'react';
import Toggle from 'react-toggle';
import defaultClasses from './reactToggle.css';
var ReactToggle = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: defaultClasses.toggle_root
  }, /*#__PURE__*/React.createElement(Toggle, props));
};
export default ReactToggle;